import { useGlobalConfig } from '../hooks';

type Url = string;
type UnlocalizedLink = string;

/**
 * Removes the language segment from a URL path.
 *
 * Accepts both relative and absolute URLs and preserves the original URL format.
 *
 * Examples:
 *   /en/history                        → /history
 *   https://localhost:44306/en/history → https://localhost:44306/history
 */
const unlocalizeLink = (url: Url): UnlocalizedLink => {
    const { $isLocalizationEnabled, $lang } = useGlobalConfig();

    if (!$isLocalizationEnabled) return url;
    
    const isRelative = url.startsWith('/');

    let link: URL;

    try {
        link = new URL(url, window.location.href);
    }
    catch {
        return String(url);
    }

    const segments = link.pathname.split('/');

    if (segments.length > 1 && segments[1] === $lang) {
        segments.splice(1, 1);
        link.pathname = segments.join('/');
    }

    return isRelative
        ? link.pathname + link.search + link.hash
        : link.toString();
};

export { unlocalizeLink }